var userAgent = require('../../useragent');

var NodeTypes = [
  'ELEMENT_NODE',
  'ATTRIBUTE_NODE',
  'TEXT_NODE',
  'CDATA_SECTION_NODE',
  'ENTITY_REFERENCE_NODE',
  'ENTITY_NODE',
  'PROCESSING_INSTRUCTION_NODE',
  'COMMENT_NODE',
  'DOCUMENT_NODE',
  'DOCUMENT_TYPE_NODE',
  'DOCUMENT_FRAGMENT_NODE',
  'NOTATION_NODE'
];

module.exports.getPath = function(node, currentTarget) {
  if (!node) {
    return null;
  }

  var path = [getNodeSignature(node, currentTarget)];
  while (node = node.parentNode) {
    path.push(getNodeSignature(node, currentTarget));
  }
  return path;
};

module.exports.getViewportSize = function() {
  var element = document.compatMode == 'CSS1Compat' ?
      document.documentElement :
      document.body;
  return {
    'width': element.clientWidth,
    'height': element.clientHeight
  };
};

module.exports.getViewportScroll = function() {
  var element = getDocumentScrollElement();
  return {
    'left': element.scrollLeft,
    'top': element.scrollTop
  };
};

function getNodeSignature(node, currentTarget) {
  var nodeType = NodeTypes[node.nodeType - 1] || node.nodeType;
  var result = {};
  if (node === currentTarget) {
    result['is_current_target'] = true;
  }

  if (nodeType === 'ELEMENT_NODE') {
    var tagName = node.tagName.toLowerCase();
    var classNames = getClassNames(node);
    if (classNames.length > 0) {
      result['classNames'] = classNames;
    }
    if (node.id) {
      result['id'] = node.id;
    }
    result['tagName'] = tagName;
    switch (tagName) {
      case 'input':
        result['name'] = node.name;
        result['type'] = node.type;
        if (node.type === 'radio' || node.type === 'checkbox') {
          result['checked'] = node.checked;
        }
        if (node.type === 'password' || node.hasAttribute('data-funnel-hidden')) {
          result['valueTrimmed50'] = '[hidden]';
        } else {
          result['valueTrimmed50'] = trim(node.value, 50);
        }
        break;
      case 'select':
      case 'textarea':
        result['name'] = node.name;
        result['valueTrimmed50'] = trim(node.value, 50);
        break;
      case 'form':
        result['action'] = node.action;
        result['method'] = node.method;
        break;
      case 'a':
      case 'span':
      case 'button':
      case 'div':
        if (node === currentTarget) {
          var textContent = node.textContent;
          if (textContent) {
            result['textContentTrimmed50'] = trim(textContent, 50);
          }
        }
    }

    return result;
  }

  result['nodeType'] = nodeType;
  return result;
};

function trim(text, length) {
  if (!text || text.length < length) {
    return text;
  }
  return text.substr(0, Math.max(length - 3, 0)) + '...';
}

function getClassNames(element) {
  var classNames = (element.getAttribute('class') || '');
  return classNames.split(/\s+/).filter(function(className) {
    return !!className;
  });
}

function getDocumentScrollElement() {
  if (document.scrollingElement) {
    return document.scrollingElement;
  }
  if (!userAgent.webkit() && document.compatMode == 'CSS1Compat') {
    return document.documentElement;
  }
  return document.body || document.documentElement;
};



//////////////////
// WEBPACK FOOTER
// ./lib/funnel/trackaction/dom.js
// module id = 25
// module chunks = 1 3